import { render, staticRenderFns } from "./topicManage.vue?vue&type=template&id=755ea873&scoped=true"
import script from "./topicManage.vue?vue&type=script&lang=js"
export * from "./topicManage.vue?vue&type=script&lang=js"
import style0 from "./topicManage.vue?vue&type=style&index=0&id=755ea873&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755ea873",
  null
  
)

export default component.exports